// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Util$SmartcutsMacros = require("../../packages/bs-utils/src/Util.bs.js");

var Unknown_response = /* @__PURE__ */Caml_exceptions.create("Next-SmartcutsMacros.GetStaticProps.Response.Unknown_response");

var Unknown_revalidate_value = /* @__PURE__ */Caml_exceptions.create("Next-SmartcutsMacros.GetStaticProps.Response.Revalidate.Unknown_revalidate_value");

function seconds(s) {
  return s;
}

function $$boolean(b) {
  return b;
}

function classify(v) {
  if (typeof v === "number") {
    return {
            TAG: /* Seconds */0,
            _0: v
          };
  }
  if (typeof v === "boolean") {
    return {
            TAG: /* Boolean */1,
            _0: v
          };
  }
  throw {
        RE_EXN_ID: Unknown_revalidate_value,
        Error: new Error()
      };
}

var Revalidate = {
  Unknown_revalidate_value: Unknown_revalidate_value,
  seconds: seconds,
  $$boolean: $$boolean,
  classify: classify
};

var PropsWithRevalidate = {};

var RedirectWithRevalidate = {};

function makePropsWithRevalidate(v) {
  return v;
}

function makeRedirectWithRevalidate(v) {
  return v;
}

function makeNotFound(param) {
  return {
          notFound: true
        };
}

function classify$1(v) {
  if (Util$SmartcutsMacros.hasSingleKey(v, "props") || Util$SmartcutsMacros.hasKeys(v, [
          "props",
          "revalidate"
        ])) {
    return {
            TAG: /* PropsWithRevalidate */0,
            _0: v
          };
  }
  if (Util$SmartcutsMacros.hasSingleKey(v, "redirect") || Util$SmartcutsMacros.hasKeys(v, [
          "redirect",
          "revalidate"
        ])) {
    return {
            TAG: /* RedirectWithRevalidate */1,
            _0: v
          };
  }
  if (Util$SmartcutsMacros.hasSingleKey(v, "notFound")) {
    return /* NotFound */0;
  }
  throw {
        RE_EXN_ID: Unknown_response,
        Error: new Error()
      };
}

var $$Response = {
  Unknown_response: Unknown_response,
  Revalidate: Revalidate,
  PropsWithRevalidate: PropsWithRevalidate,
  RedirectWithRevalidate: RedirectWithRevalidate,
  makePropsWithRevalidate: makePropsWithRevalidate,
  makeRedirectWithRevalidate: makeRedirectWithRevalidate,
  makeNotFound: makeNotFound,
  classify: classify$1
};

var GetStaticProps = {
  $$Response: $$Response
};

var GetStaticPaths = {};

var Link = {};

var Events = {};

var Router = {
  Events: Events
};

var Head = {};

var WithInnerHtml = {};

var Script = {
  WithInnerHtml: WithInnerHtml
};

var $$Error = {};

var $$Request = {};

var $$Response$1 = {};

function MakeContext(Context) {
  return {};
}

var ExtraContextProperties = {};

function AppContext_pathname(prim) {
  return prim.pathname;
}

function AppContext_query(prim) {
  return prim.query;
}

function AppContext_asPath(prim) {
  return prim.asPath;
}

function AppContext_req(prim) {
  return prim.req;
}

function AppContext_res(prim) {
  return prim.res;
}

function AppContext_err(prim) {
  return prim.err;
}

var AppContext = {
  pathname: AppContext_pathname,
  query: AppContext_query,
  asPath: AppContext_asPath,
  req: AppContext_req,
  res: AppContext_res,
  err: AppContext_err
};

function MakePageContext(Context, AppContext) {
  return {
          pathname: (function (prim) {
              return prim.pathname;
            }),
          query: (function (prim) {
              return prim.query;
            }),
          asPath: (function (prim) {
              return prim.asPath;
            }),
          req: (function (prim) {
              return prim.req;
            }),
          res: (function (prim) {
              return prim.res;
            }),
          err: (function (prim) {
              return prim.err;
            }),
          appContext: (function (prim) {
              return prim.ctx;
            }),
          appTree: (function (prim) {
              return prim.AppTree;
            })
        };
}

function PageContext_pathname(prim) {
  return prim.pathname;
}

function PageContext_query(prim) {
  return prim.query;
}

function PageContext_asPath(prim) {
  return prim.asPath;
}

function PageContext_req(prim) {
  return prim.req;
}

function PageContext_res(prim) {
  return prim.res;
}

function PageContext_err(prim) {
  return prim.err;
}

function PageContext_appContext(prim) {
  return prim.ctx;
}

function PageContext_appTree(prim) {
  return prim.AppTree;
}

var PageContext = {
  pathname: PageContext_pathname,
  query: PageContext_query,
  asPath: PageContext_asPath,
  req: PageContext_req,
  res: PageContext_res,
  err: PageContext_err,
  appContext: PageContext_appContext,
  appTree: PageContext_appTree
};

var $$Response$2 = {};

var GetServerSideProps = {
  $$Response: $$Response$2
};

function inject(_cls, _fn) {
  return (_cls.getInitialProps = _fn);
}

function overrideToJSONAsNull(_apolloClient) {
  return (_apolloClient.toJSON = () => null);
}

exports.GetStaticProps = GetStaticProps;
exports.GetStaticPaths = GetStaticPaths;
exports.Link = Link;
exports.Router = Router;
exports.Head = Head;
exports.Script = Script;
exports.$$Error = $$Error;
exports.$$Request = $$Request;
exports.$$Response = $$Response$1;
exports.MakeContext = MakeContext;
exports.ExtraContextProperties = ExtraContextProperties;
exports.AppContext = AppContext;
exports.MakePageContext = MakePageContext;
exports.PageContext = PageContext;
exports.GetServerSideProps = GetServerSideProps;
exports.inject = inject;
exports.overrideToJSONAsNull = overrideToJSONAsNull;
/* Util-SmartcutsMacros Not a pure module */
